export enum LeadClientMeetingStatus {
    None = 0,
    Planned = 1,
    Held = 2,
    NotHeld = 3
}
